import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox, Timestamp } from '@dixa/lib-shared-habla';
import { useConversationRow } from '../../../utils/useConversationRow';
import styles from './conversationsTableTimestamp.module.scss';
/** Represents the content of a timestamp cell in the conversations table. */
export const ConversationsTableTimestamp = ({ timestampKey, }) => {
    const { conversationAndRequester: { conversation }, } = useConversationRow();
    const timestamp = conversation[timestampKey];
    return (_jsx(FlexBox, Object.assign({ display: "inline-flex", alignItems: "center" }, { children: timestamp && (_jsx(Timestamp, { className: styles.timestamp, time: timestamp, relative: true })) })));
};
